import React from 'react';
import PropTypes from 'prop-types';

import ModalProductGroup from 'components/GroupedProductList/ModalProductGroup';

const groupedProductListDefaultPropProductGroups = [];

const GroupedProductList = ({ productGroups = groupedProductListDefaultPropProductGroups }) =>
  productGroups.map(productGroup => {
    const { message } = productGroup;

    return (
      <ModalProductGroup
        {...productGroup}
        key={`product-group-${message ? message.replace(/ /gi, '-') : 'undefined'}`}
      />
    );
  });

GroupedProductList.displayName = 'GroupedProductList';

GroupedProductList.propTypes = {
  productGroups: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string,
    }),
  ),
};

export default GroupedProductList;
